import {
  Card,
  CardContent,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import moment from "moment";
import { displayDate } from "utils/Date";
import MDTypography from "components/MDTypography";
import { useSelector } from "react-redux";
import React from "react";
import MDBox from "components/MDBox";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import TemplateRound from "../MyTeam/TemplateRound";

function ReportsListing({ reports, setSelectedReport, selectedReportId }) {
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);

  return (
    <Card sx={{ height: "64vh", overflowY: "auto" }}>
      <CardContent sx={{ p: 2 }}>
        <MDTypography variant="h5">Archive</MDTypography>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: "none", "& .MuiTableCell-root ": { borderBottom: "none" }, mt: 1 }}
        >
          <Table aria-label="simple table">
            <TableBody>
              {reports?.map((report, index) => (
                <TableRow
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  sx={{ cursor: "pointer" }}
                  onClick={() => setSelectedReport(report)}
                >
                  <TableCell
                    sx={{
                      background: report?.id === selectedReportId && "#d7d7d7",
                      borderRadius: "16px",
                      p: 0,
                    }}
                  >
                    <TableCell width="5%">
                      <TemplateRound
                        title=""
                        color={report?.CoachupTemplate?.color}
                        open={report.statusId !== "Close"}
                      />
                    </TableCell>
                    <TableCell width="40%">
                      <Stack spacing={1}>
                        <MDTypography variant="caption" fontWeight="medium" fontSize="14px">
                          {report.CoachupTemplate?.name}
                        </MDTypography>
                        <MDTypography variant="caption">{report.statusId}</MDTypography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <MDTypography sx={{ fontSize: "14px", whiteSpace: "noWrap" }}>
                        {displayDate(moment.tz(report.createdAt, loginUserState.timezone))}
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDBox sx={{ display: "flex" }}>
                        <KeyboardArrowRightIcon />
                      </MDBox>
                    </TableCell>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

export default ReportsListing;
